/** API route map: URLS.Controller.BillingRule */
export const BillingRule = {
      Name: 'BillingRule/',
      GetAllBillingRule: 'get-all-billing-rule',
      AddBillingRule: 'add-billing-rule',
      DeleteBillingRule: 'delete-billing-rule',
      UpdateBillingRule: 'Update',
      GetIterationCount: 'get-iteration-count',
};
